import * as React from 'react';

class SimpleInputAgGridEditor extends React.Component {
  state = {
    inpVal: '',
  };

  componentDidMount() {
    const {value} = this.props;

    this.setState({inpVal: value})
  }

  getValue = () => {
    return this.state.inpVal;
  };

  onChange = (e) => {
    const {agGridReact,node,column} = this.props;
    const {currentValuesChanges} = agGridReact.props;
    let data = node.data;

    data[column.colId] = e.target.value;
    currentValuesChanges(data);
    this.validationSetter(e.target.value);
    this.setState({inpVal: e.target.value});
  };

  validationSetter = (value) => {
    const {type, column, agGridReact, node,required} = this.props;
    const {setError} = agGridReact.props;

    if (required && value === '') {
      setError(node.data.projectIndex, 'Field is required', column.colId);
    } else {
      if (type === "number") {
        if (+value !== 0 && !+value) {

          setError(node.data.projectIndex, 'Field must be Number', column.colId);
        } else {
          setError(node.data.projectIndex, '', column.colId)
        }
      } else if (type === "integer") {
        if (!Number.isInteger(+value)) {
          setError(node.data.projectIndex, 'Field must be Integer', column.colId);
        } else {
          setError(node.data.projectIndex, '', column.colId)
        }
      }
    }
  };

  render() {
    const {inpVal} = this.state;

    return <input type="text" value={inpVal} onChange={this.onChange}/>;
  }
}
export default SimpleInputAgGridEditor;


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/FieldRenderer/SimpleInputAgGridEditor.js